/**
 * ## javascript Tabs module Usage
 *
 * ### Markup:
 * <div class="tabs">
 *   <ul class="tabs__tablist" role="tablist">
 *       <li role="presentation"><a id="tab1" role="tab" href="#tab-title1" aria-selected="true">Tab Title 1</a></li>
 *       <li role="presentation"><a id="tab2" role="tab" href="#tab-title2">Tab Title 2</a></li>
 *   </ul>
 *   <section id="tab-title1" class="tabs__panel rtecontent" role="tabpanel" tabindex="-1" role="tabpanel" aria-labelledby="tab1">
 *       Tab Content Goes Here
 *   </section>
 *   <section id="tab-title2" class="tabs__panel rtecontent" role="tabpanel" tabindex="-1" role="tabpanel" aria-labelledby="tab2">
 *       Tab Content Goes Here
 *   </section>
 * </div>
 * 
 **/
export default (($) => {

    return function() {

        // Get relevant elements and collections
        const tabbed = document.querySelector('.tabs');
        const tablist = tabbed.querySelector('ul.tabs__tablist');
        const tabs = tablist.querySelectorAll('a');
        const panels = tabbed.querySelectorAll('.tabs__panel');
        const hashtag = window.location.hash;

        // The tab switching function
        const switchTab = (oldTab, newTab) => {
            newTab.focus();
            // Make the active tab focusable by the user (Tab key)
            newTab.removeAttribute('tabindex');
            // Set the selected state
            newTab.setAttribute('aria-selected', 'true');
            oldTab.removeAttribute('aria-selected');
            oldTab.setAttribute('tabindex', '-1');

            // Get the indices of the new and old tabs to find the correct
            // tab panels to show and hide
            let index = Array.prototype.indexOf.call(tabs, newTab);
            let oldIndex = Array.prototype.indexOf.call(tabs, oldTab);
            panels[oldIndex].hidden = true;
            panels[index].hidden = false;

            let hash = newTab.getAttribute('href');
            console.log(hash);
            window.location.hash = hash;
        }

        console.log(hashtag);
        if( hashtag ){
            let hashTab = tablist.querySelector('[href="' + hashtag + '"]');
            let starterTab = tablist.querySelector('[aria-selected]');
            if (hashTab !== starterTab) {
                switchTab(starterTab, hashTab);
            }
        }
        
        // Add listeners for selecting tabs
        Array.prototype.forEach.call(tabs, (tab, i) => {
            // Handle clicking of tabs for mouse users
            tab.addEventListener('click', e => {
                e.preventDefault();
                let currentTab = tablist.querySelector('[aria-selected]');
                if (e.currentTarget !== currentTab) {
                    switchTab(currentTab, e.currentTarget);
                }
            });

            // Handle keydown events for keyboard users
            tab.addEventListener('keydown', e => {
                // Get the index of the current tab in the tabs node list
                let index = Array.prototype.indexOf.call(tabs, e.currentTarget);
                // Work out which key the user is pressing and
                // Calculate the new tab's index where appropriate
                let dir = e.which === 37 ? index - 1 : e.which === 39 ? index + 1 : e.which === 40 ? 'down' : null;
                if (dir !== null) {
                    e.preventDefault();
                    // If the down key is pressed, move focus to the open panel,
                    // otherwise switch to the adjacent tab
                    dir === 'down' ? panels[i].focus() : tabs[dir] ? switchTab(e.currentTarget, tabs[dir]) : void 0;
                }
            });
        });
        

    }

})(jQuery)
